export const AccountType = {
  Premium: "Premium",
  Freemium: "Freemium",
};
